












































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class AppListSelector extends Vue {
  @Prop({ type: Array }) readonly value!: number[]
  @Prop(String) readonly label!: string
  @Prop(String) readonly leftTitle!: string
  @Prop(String) readonly rightTitle!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: [Number, String], default: 289 }) readonly width!: number | string
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: Array }) readonly items!: string[]
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  model: number[] = []

  options: any[] = []

  get selected () {
    return this.options.filter(opt => opt.selected)
  }

  get unSelected () {
    return this.options.filter(opt => !opt.selected)
  }

  mounted () {
    const options: any = []

    for (const [i, v] of this.items.entries()) {
      options.push({
        index: i,
        selected: false,
        value: v
      })
    }

    this.value.map(val => {
      options[val].selected = true
    })

    this.options = options
    this.model = this.value
  }

  @Emit('input')
  valueChangedHandler () {
    return this.model
  }

  addOption (index: number) {
    this.options[index].selected = true
    this.model.push(index)
    this.valueChangedHandler()
  }

  removeOption (index: number) {
    this.options[index].selected = false
    this.model = this.$R.without([index], this.model)
    this.valueChangedHandler()
  }
}
